import React, { useEffect, useState } from 'react'
import { TextField } from '@mui/material';
import { isOnlyDigit } from '../../../services/services';
import { updateDateStartEnd, updateNDaysFromActivation } from '../../../../../stateManagement/actions/manageCouponActions';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { labelMappings } from '../../../utils/utils';
interface NormalCalendarProps {
    daysFromActivation: string;
    setDaysFromActivation: (updatedState: string) => void;
    disableTextField:boolean;
}

function NormalCalendar({ daysFromActivation, setDaysFromActivation,disableTextField }: NormalCalendarProps) {

    const handleDaysChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = (event.target as HTMLInputElement).value.trim().replace(/^0+/, '');
        if (isOnlyDigit(inputValue)) {
            setDaysFromActivation(inputValue);
        }
    }
    return (
        <div className='applicable-slab-single-field' style={{ display: 'flex', alignItems: 'center', marginBottom: "5px" }}>
            <div className="applicable-slab-single-field-left" style={{ width: '30%', margin: "10px" }}>
                <p style={{ color: '#989898', fontSize: '14px', fontWeight: "bold" }}>{labelMappings["N-days-label"]}</p>
            </div>
            <TextField
                disabled={disableTextField}
                value={daysFromActivation}
                onChange={handleDaysChange}
                id="outlined-basic"
                placeholder="Write Here"
                variant="outlined"
                size="small"
            />
        </div>
    )
}

export default React.memo(NormalCalendar)